import { Namespace } from '../translation/namespace';
import i18next from '../translation/i18n';
import ILink from '../types/ILink';
import { PagePackStates, PagePackState } from '../types/api/PagePackState';

export function getTitle({
  link,
  title,
  packState,
}: {
  link: ILink;
  title: string;
  packState: PagePackStates;
}): string {
  // add a title attribute if link name differs from title
  let linkTitle = title !== link.name ? title : '';

  if (packState === PagePackState.TEMPLATE) {
    linkTitle += ` (${i18next.t(`${Namespace.glossary}:template`)})`;
  }
  if (packState === PagePackState.ONLY_DRAFT_VERSION) {
    linkTitle += ` (${i18next.t(`${Namespace.glossary}:draft`)})`;
  }

  return linkTitle;
}
